import {
  pageEvent,
  trackEvent,
  getCommonEventProperties,
  waitForAnalyticsLoad,
} from "@acko-tech/building-blocks.ui.acko-analytics";
import {
  getCurrentPageType,
  getExternalReferrer,
  segmentEventCommonProp,
} from "./utils";

export enum EventType {
  PAGE_EVENT = "page",
  TRACK_EVENT = "track",
  IDENTIFY_EVENT = "identify",
}
export interface EventTrackerOptions {
  pageType?: string;
  additionalProps?: Record<string, any>;
  customWriteKey?: string;
}

export const trackEventWithCommonProps = async (
  eventName: string,
  eventType: EventType = EventType.TRACK_EVENT,
  options: EventTrackerOptions = {}
): Promise<void> => {
  try {
    const { pageType, additionalProps = {}, customWriteKey } = options;

    await waitForAnalyticsLoad();

    const commonProps = segmentEventCommonProp();
    const ackoCommonProps = getCommonEventProperties(
      pageType || getCurrentPageType()
    );

    let source = "";
    if (typeof window !== "undefined") {
      const storedSource = sessionStorage.getItem("referrerSource");

      if (storedSource) {
        source = storedSource;
      } else {
        const currentSource = getExternalReferrer();
        if (
          currentSource &&
          !currentSource.includes("ackodrive.com") &&
          !currentSource.includes("acko.com")
        ) {
          source = currentSource;
          sessionStorage.setItem("referrerSource", currentSource);
        }
      }
    }

    const eventProperties = {
      ...Object.fromEntries(
        Object.entries(ackoCommonProps).filter(([_, v]) => v != "")
      ),
      ...Object.fromEntries(
        Object.entries(commonProps).filter(([_, v]) => v !== "")
      ),
      ...additionalProps,
    };

    // Manually override source - always set it
    (eventProperties as any)["source"] = source || "";

    switch (eventType) {
      case EventType.PAGE_EVENT:
        await pageEvent(eventName, eventProperties, customWriteKey);
        break;
      case EventType.TRACK_EVENT:
        await trackEvent(eventName, eventProperties, customWriteKey);
        break;
      case EventType.IDENTIFY_EVENT:
        await trackEvent(eventName, eventProperties, customWriteKey);
        break;
      default:
        console.error(`Invalid event type: ${eventType}`);
        break;
    }
  } catch (error) {
    console.error("Error tracking event:", error);
  }
};
